import React, { Component } from 'react';
import PropTypes from 'prop-types';

import styles from './Timeline.module.scss';

import { Container } from 'common/components/Layout/Layout';

class Timeline extends Component {
  static propTypes = {
    children: PropTypes.node
  };

  render() {
    return (
      <Container className={styles.Timeline}>
        <Container className={styles.VerticalLineContainer}>
          <div className={styles.VerticalLine} />
        </Container>
        {this.props.children}
      </Container>
    );
  }
}

export default Timeline;



// WEBPACK FOOTER //
// ./src/views/History/components/Timeline/Timeline.js